<div class="mt-2">
  @if (neskoEntry) {
    <cap-content-header class="externe-daten">
      <cap-title>
        {{ neskoEntry.grundstueckArt }}
        <cap-kompakt-neskoab-grundstueck [canNavigate]="false" [item]="neskoEntry"></cap-kompakt-neskoab-grundstueck>
      </cap-title>
    </cap-content-header>
  }

  @if (neskoEntry) {
    <div class="row mt-2">
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement label="Gemeinde">
          {{ neskoEntry.gemeinde?.name | translateName }}, {{ neskoEntry.gemeinde?.bfsNummer }}
          @if (neskoEntry.gemeinde.kreisNummer) {
            <span>.{{ neskoEntry.gemeinde.kreisNummer }}</span>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="Nummer">
          {{ gsNummer }}
        </cap-kopfdatenelement>
      </div>
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement label="Grundstuecksart">
          {{ neskoEntry?.grundstueckArt | translate }}
        </cap-kopfdatenelement>
      </div>
    </div>
  }

  <cap-nesko-amtliche-bewertung [awDetailEntry]="neskoEntry?.amtlicherWert" [hasRight]="hasRightAmtlicherWert">
  </cap-nesko-amtliche-bewertung>

  <cap-objekte
    [hasRight]="hasRightObjekte"
    [isAmtlicherWertVerteilt]="neskoEntry?.amtlicherWert?.isAmtlicherWertVerteilt"
    [objekte]="neskoEntry?.objekte">
  </cap-objekte>

  <cap-rubrik [isClosable]="false" [isOpen]="true" class="externe-daten">
    <ng-container title>
      <h2 class="mb-0">{{ "neskoab.EigentumVerteiler" | translate }}</h2>
    </ng-container>
    @if (neskoEntry?.verteiler || neskoEntry?.eigentum) {
    } @else {
      <div class="mb-2">
        <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
      </div>
    }
    @if (neskoEntry?.verteiler) {
      <cap-neskoab-grundstueck-eigentum
        [eigentum]="neskoEntry?.verteiler"
        [eigentumsform]="neskoEntry?.eigentum?.eigentumForm"
        [hasRight]="hasRightVerteiler">
      </cap-neskoab-grundstueck-eigentum>
    }
    @if (neskoEntry?.eigentum && !neskoEntry?.verteiler) {
      <cap-neskoab-personen-eigentum [eigentum]="[neskoEntry?.eigentum]" [hasRight]="hasRightEigentum"></cap-neskoab-personen-eigentum>
    }
  </cap-rubrik>

  <cap-neskoab-nutzniesser [hasRight]="hasRightNutzniessung" [nutzniesser]="neskoEntry?.nutzniesser"></cap-neskoab-nutzniesser>
</div>
